import { Injectable } from '@angular/core';
import { Travel } from '../models/travel';
import { Order } from '../models/order';
import { WebsocketService } from './websocket.service';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface EventMessage{
  type:string, 
  travel?:Travel, 
  order?:Order
}

@Injectable({
  providedIn: 'root'
})
export class LogisticEventsService {

  conection:Subject<EventMessage>;

  constructor(private WebSocketServ:WebsocketService<EventMessage>) {
    this.conection = this.WebSocketServ.connect(environment.baseUrlWs);
  }

  wait(callback:(resp:MessageEvent) => void) {
    this.conection.subscribe(callback)
  }

  sendTravelCreated(travel:Travel) {
    this.send('travel-created', travel);
  }

  sendTravelDeleted(travel:Travel) {
    this.send('travel-deleted', travel);
  }

  sendOrderCreated(order:Order) {
    this.send('order-created', null, order);
  }

  sendOrderDeleted(order:Order) {
    this.send('order-deleted', null, order);
  }

  sendOrderChangeInfo(order:Order) {
    this.send('order-info-changed', null, order);
  }

  send(type:string, travel?:Travel, order?:Order) {
    this.conection.next({
      type,
      travel,
      order,
    });
  }
}
